import { useState } from 'react'
import Accordion from '@/components/generics/Accordion'
import arrowSubMenu from '@/assets/imgs/arrow-submenu.svg'
import { SIDEBAR_MENU as dict } from '@/resources/dict'
import { SidebarMenuItem } from '@/resources/types'
import SplitControlledMenuItem from '../SplitControlledMenuItem'
import * as S from './styles'

interface Props {
  menuItem: SidebarMenuItem
  onClick?: () => void
}

const MENU_ITEM_HEIGHT = 48

const Submenu = ({ menuItem, onClick }: Props) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <>
      {menuItem.submenu && (
        <Accordion
          id={`menu-accordion-${menuItem.id}`}
          accordionShow={true}
          header={
            <S.Submenu
              data-expanded={isExpanded}
              data-testid="submenu-heading"
              id={`submenu-heading-${menuItem.id}`}
            >
              <span>{menuItem.text}</span>
              <S.Arrow
                src={arrowSubMenu}
                alt={isExpanded ? dict.submenuClose : dict.submenuOpen}
              />
            </S.Submenu>
          }
          body={menuItem.submenu.map((item: SidebarMenuItem) => (
            <SplitControlledMenuItem
              menuItem={item}
              key={`menu-item-${item.id}`}
              onClick={onClick}
              isSubmenu
            />
          ))}
          bodyId={`submenu-${menuItem.id}`}
          bodyHeight={MENU_ITEM_HEIGHT * menuItem.submenu.length}
          onAccordionChange={setIsExpanded}
        />
      )}
    </>
  )
}

export default Submenu
